export class ReportesHelpers {
  static truncarTexto(texto, maxLength) {
    if (texto.length <= maxLength) {
      return texto;
    }
    return texto.substring(0, maxLength) + '...';
  }

  static formatearFecha(fecha) {
    if (!fecha) return '';
    const [year, month, day] = fecha.split('-');
    return `${day}/${month}/${year}`;
  }

  static construirParametrosReporte(filtros) {
    const params = {
      page: filtros.page || 1,
      limit: filtros.limit || 10,
    };
    // Debug general para todos los reportes especiales
    console.log('🔍 construirParametrosReporte - Filtros recibidos:', {
      esOperacion: filtros.esOperacion,
      reporteEspecialActivo: filtros.reporteEspecialActivo,
      fechaInicio: filtros.fechaInicio,
      fechaFinal: filtros.fechaFinal,
      fechaDisponibleSaldosHTC: filtros.fechaDisponibleSaldosHTC,
    });


    // Debug para Info Cobranzas Proyectadas
    if (filtros.reporteEspecialActivo === 'Info Cobranzas Proyectadas') {
      console.log('🔍 Info Cobranzas - Filtros recibidos:', {
        filtroOperatoria: filtros.filtroOperatoria,
        filtroOperatoriaLength: filtros.filtroOperatoria
          ? filtros.filtroOperatoria.length
          : 'undefined',
        filtroOperatoriaType: typeof filtros.filtroOperatoria,
        filtroFideicomiso: filtros.filtroFideicomiso,
        operatorias:
          filtros.operatorias && filtros.operatorias.length > 0
            ? filtros.operatorias
            : null,
        operatoriasLength: filtros.operatorias
          ? filtros.operatorias.length
          : 'undefined',
        fideicomisos:
          filtros.fideicomisos && filtros.fideicomisos.map
            ? filtros.fideicomisos.map((fid) => ({
                nombre: fid.nombre,
                id: fid.id,
              }))
            : null,
      });

      // Debug específico de operatorias
      if (filtros.operatorias && filtros.operatorias.length > 0) {
        console.log('🔍 Detalle de operatorias disponibles:');
        filtros.operatorias.forEach((op, index) => {
          console.log(`${index}: ${op.nombre}`, op);
        });
      }

      // Debug específico del array filtroOperatoria
      if (filtros.filtroOperatoria) {
        console.log('🔍 Contenido de filtroOperatoria:', {
          esArray: Array.isArray(filtros.filtroOperatoria),
          length: filtros.filtroOperatoria.length,
          contenido: filtros.filtroOperatoria,
        });

        if (Array.isArray(filtros.filtroOperatoria)) {
          filtros.filtroOperatoria.forEach((item, index) => {
            console.log(`filtroOperatoria[${index}]:`, item);
          });
        }
      }
    }

    // Estados - manejar selección múltiple
    if (filtros.estadoSeleccionado && filtros.estadoSeleccionado.length > 0) {
      if (filtros.estadoSeleccionado.includes('todas')) {
        params.estadosIds = [1, 2, 3, 4, 5, 6, 7, 12, 22].join(',');
      } else {
        params.estadosIds = filtros.estadoSeleccionado.join(',');
      }
    } else {
      params.estadosIds = [1, 2, 3, 4, 5, 6, 7, 12, 22].join(',');
    }

    // Operatorias - convertir nombres a IDs
    if (
      filtros.filtroOperatoria &&
      filtros.filtroOperatoria.length > 0 &&
      !filtros.filtroOperatoria.includes('Todas')
    ) {
      const operatoriasIds = filtros.filtroOperatoria
        .map((nombreOperatoria) => {
          const operatoria = filtros.operatorias.find(
            (op) => op.nombre === nombreOperatoria
          );
          return operatoria ? operatoria.id : null;
        })
        .filter((id) => id !== null);

      if (operatoriasIds.length > 0) {
        params.operatoriasIds = operatoriasIds.join(',');

        // Para Info Cobranzas Proyectadas, también mapear operatorias a fideicomisos
        if (filtros.reporteEspecialActivo === 'Info Cobranzas Proyectadas') {
          const fideicomisosDesdeOperatorias = filtros.filtroOperatoria
            .map((nombreOperatoria) => {
              const operatoria = filtros.operatorias.find(
                (op) => op.nombre === nombreOperatoria
              );
              if (!operatoria) return null;

              // Probar diferentes propiedades que puedan contener el fideicomiso ID
              let fideicomisoId = null;
              if (operatoria.fideicomiso && operatoria.fideicomiso.id) {
                fideicomisoId = operatoria.fideicomiso.id;
              } else if (operatoria.fideicomisoId) {
                fideicomisoId = operatoria.fideicomisoId;
              } else if (operatoria.unidadGestionId) {
                fideicomisoId = operatoria.unidadGestionId;
              }

              console.log('🔍 Mapeo operatoria:', {
                nombre: nombreOperatoria,
                operatoria: operatoria,
                fideicomisoId: fideicomisoId,
              });

              return fideicomisoId;
            })
            .filter((id) => id !== null && id !== undefined);

          if (fideicomisosDesdeOperatorias.length > 0) {
            params.fideicomisosId = [
              ...new Set(fideicomisosDesdeOperatorias),
            ].join(',');
            console.log(
              '🔍 Info Cobranzas: Mapeando operatorias a fideicomisos:',
              {
                operatorias: filtros.filtroOperatoria,
                fideicomisosId: params.fideicomisosId,
              }
            );
          }
        }
      }
    }

    // Fideicomisos - convertir nombres a IDs
    if (filtros.filtroFideicomiso) {
      let fideicomisosIds = [];

      // Manejar tanto string (Info Mora) como array (reportes normales)
      if (typeof filtros.filtroFideicomiso === 'string') {
        // Caso string - Info Mora con selección única
        if (filtros.filtroFideicomiso !== 'Todas') {
          const fideicomiso = filtros.fideicomisos.find(
            (fid) => fid.nombre === filtros.filtroFideicomiso
          );
          if (fideicomiso) {
            fideicomisosIds = [fideicomiso.id];
          }
        }
      } else if (
        Array.isArray(filtros.filtroFideicomiso) &&
        filtros.filtroFideicomiso.length > 0 &&
        !filtros.filtroFideicomiso.includes('Todas')
      ) {
        // Caso array - reportes normales con selección múltiple
        fideicomisosIds = filtros.filtroFideicomiso
          .map((nombreFideicomiso) => {
            const fideicomiso = filtros.fideicomisos.find(
              (fid) => fid.nombre === nombreFideicomiso
            );
            return fideicomiso ? fideicomiso.id : null;
          })
          .filter((id) => id !== null);
      }

      if (fideicomisosIds.length > 0) {
        params.fideicomisosId = fideicomisosIds.join(',');
      }
    }

    // Tipo de Operatoria
    if (filtros.filtroTipoServicio) {
      params.tipoOperatoria = filtros.filtroTipoServicio;
    } else if (
      filtros.esOperacion === 'Info Mora (Financiamiento)' ||
      filtros.reporteEspecialActivo === 'Info Mora (Financiamiento)'
    ) {
      // Para Info Mora Financiamiento, siempre usar el ID del servicio de Financiamiento
      params.tipoOperatoria = 13;
    } else if (
      filtros.esOperacion === 'Info Cobranzas Proyectadas' ||
      filtros.reporteEspecialActivo === 'Info Cobranzas Proyectadas'
    ) {
      // Para Info Cobranzas Proyectadas, siempre usar el ID del servicio de Financiamiento
      params.tipoOperatoria = 13;
    } else if (
      filtros.esOperacion === 'Info Cobranzas' ||
      filtros.reporteEspecialActivo === 'Info Cobranzas'
    ) {
      // Para Info Cobranzas, siempre usar el ID del servicio de Financiamiento
      params.tipoOperatoria = 13;
    } else if (
      filtros.esOperacion === 'Info Cte y No Cte' ||
      filtros.reporteEspecialActivo === 'Info Cte y No Cte'
    ) {
      // Para Info Cte y No Cte, siempre usar el ID del servicio de Financiamiento
      params.tipoOperatoria = 13;
    } else if (
      filtros.esOperacion === 'Reporte de Saldos - HTC' ||
      filtros.reporteEspecialActivo === 'Reporte de Saldos - HTC'
    ) {
      // Para Saldos HTC, siempre usar el ID del servicio de Financiamiento
      params.tipoOperatoria = 13;
    }

    // Fechas
    if (filtros.fechaInicio) {
      params.fechaDesde = filtros.fechaInicio;
    }
    if (filtros.fechaFinal) {
      params.fechaHasta = filtros.fechaFinal;
    }

    // Tipo de persona
    if (filtros.filtroTipoPersona && filtros.filtroTipoPersona !== 'Ambas') {
      if (filtros.filtroTipoPersona === 'Física') {
        params.tipoPersona = 1;
      } else if (filtros.filtroTipoPersona === 'Jurídica') {
        params.tipoPersona = 0;
      }
    }

    // Departamentos - manejar selección múltiple
    if (filtros.filtroDepartamento && filtros.filtroDepartamento.length > 0) {
      params.departamentosIds = filtros.filtroDepartamento.join(',');
    }

    // Subtotales por operatoria (para tipos que soportan subtotales)
    if (
      filtros.mostrarSubtotales &&
      (filtros.esOperacion === 'Financiamiento' ||
        filtros.filtroTipoServicio === 13)
    ) {
      params.incluir_subtotales = true;
    }

    // Para Info Cte y No Cte, siempre incluir subtotales por operatoria
    if (
      filtros.esOperacion === 'Info Cte y No Cte' ||
      filtros.reporteEspecialActivo === 'Info Cte y No Cte'
    ) {
      params.incluir_subtotales = true;
      // El filtrado de operatorias activas se hace en frontend, no en backend

      // Para Info Cte y No Cte usar fechadecorte basada en el período disponible
      if (filtros.fechaDisponibleCteYNoCte) {
        // Usar la fecha del período disponible obtenida del endpoint /available-dates
        params.fechadecorte = filtros.fechaDisponibleCteYNoCte;
        console.log('📅 Usando fecha de período disponible:', params.fechadecorte);
      } else if (filtros.fechaFinal) {
        // Fallback: usar fecha final si está disponible
        params.fechadecorte = filtros.fechaFinal;
        console.log('📅 Usando fecha final como fallback:', params.fechadecorte);
      } else {
        // Último fallback: usar fecha actual
        params.fechadecorte = new Date().toISOString().substr(0, 10);
        console.log('📅 Usando fecha actual como último fallback:', params.fechadecorte);
      }

      // Remover fechaDesde y fechaHasta para este reporte
      delete params.fechaDesde;
      delete params.fechaHasta;
    }

    console.log('🔍 Verificando condición Saldos HTC:', {
      esOperacion: filtros.esOperacion,
      reporteEspecialActivo: filtros.reporteEspecialActivo,
      cumpleCondicion: filtros.esOperacion === 'Reporte de Saldos - HTC' || filtros.reporteEspecialActivo === 'Reporte de Saldos - HTC'
    });

    // Para Saldos HTC, también usar fechadecorte basada en el período disponible
    if (
      filtros.esOperacion === 'Reporte de Saldos - HTC' ||
      filtros.reporteEspecialActivo === 'Reporte de Saldos - HTC'
    ) {
      params.incluir_subtotales = true;
      // Usar fecha de corte disponible
      if (filtros.fechaDisponibleSaldosHTC) {
        params.fechadecorte = filtros.fechaDisponibleSaldosHTC;
        console.log('📅 Saldos HTC - Usando fecha de período disponible:', params.fechadecorte);
      } else if (filtros.fechaFinal) {
        params.fechadecorte = filtros.fechaFinal;
        console.log('📅 Saldos HTC - Usando fecha final como fallback:', params.fechadecorte);
      } else {
        params.fechadecorte = new Date().toISOString().substr(0, 10);
        console.log('📅 Saldos HTC - Usando fecha actual como último fallback:', params.fechadecorte);
      }
      // Remover fechaDesde y fechaHasta para este reporte
      delete params.fechaDesde;
      console.log('✅ Saldos HTC - Fechas eliminadas. Parámetros actuales:', params);
      delete params.fechaHasta;
    }

    // Lógica específica para Info Cobranzas Proyectadas - mapear operatoria seleccionada a fideicomiso
    if (
      filtros.reporteEspecialActivo === 'Info Cobranzas Proyectadas' &&
      filtros.filtroOperatoria &&
      Array.isArray(filtros.filtroOperatoria) &&
      filtros.filtroOperatoria.length > 0
    ) {
      console.log(
        '🔍 Procesando operatorias para Info Cobranzas Proyectadas:',
        filtros.filtroOperatoria
      );

      // Mapeo temporal hardcoded para Info Cobranzas Proyectadas
      // TODO: Investigar por qué filtros.operatorias no contiene las operatorias reales
      const mapeoOperatoriaFideicomiso = {
        'Semilla IV': { operatoriaId: 118, fideicomisoId: 15 },
        'Mendoza Produce': { operatoriaId: 127, fideicomisoId: 15 },
        'Mendoza Innova': { operatoriaId: 117, fideicomisoId: 15 }, // Agregado para Mendoza Innova (ID corregido)
        // Agregar más mapeos según sea necesario
      };

      const fideicomisosDesdeOperatorias = [];
      const operatoriasIds = [];

      filtros.filtroOperatoria.forEach((nombreOperatoria) => {
        console.log(`🔍 Buscando operatoria: ${nombreOperatoria}`);

        // Primero intentar buscar en las operatorias disponibles
        let operatoriaEncontrada = false;
        if (filtros.operatorias && filtros.operatorias.length > 0) {
          const operatoria = filtros.operatorias.find(
            (op) => op.nombre === nombreOperatoria
          );

          if (operatoria && operatoria.nombre !== 'Todas') {
            console.log('🔍 Operatoria encontrada en lista:', operatoria);

            // Intentar obtener el fideicomiso ID de diferentes propiedades
            let fideicomisoId = null;
            if (operatoria.fideicomiso && operatoria.fideicomiso.id) {
              fideicomisoId = operatoria.fideicomiso.id;
            } else if (operatoria.fideicomisoId) {
              fideicomisoId = operatoria.fideicomisoId;
            } else if (operatoria.unidadGestionId) {
              fideicomisoId = operatoria.unidadGestionId;
            }

            if (fideicomisoId) {
              fideicomisosDesdeOperatorias.push(fideicomisoId);
              if (operatoria.id) {
                operatoriasIds.push(operatoria.id);
              }
              operatoriaEncontrada = true;
            }
          }
        }

        // Siempre usar el mapeo hardcoded si está disponible (prioridad alta)
        if (mapeoOperatoriaFideicomiso[nombreOperatoria]) {
          console.log(
            `🔍 Usando mapeo hardcoded para: ${nombreOperatoria} (prioridad)`
          );
          const mapeo = mapeoOperatoriaFideicomiso[nombreOperatoria];
          fideicomisosDesdeOperatorias.push(mapeo.fideicomisoId);
          operatoriasIds.push(mapeo.operatoriaId);
          console.log(
            `🔍 FideicomisoId: ${mapeo.fideicomisoId}, OperatoriaId: ${mapeo.operatoriaId}`
          );
          operatoriaEncontrada = true;
        }

        // Solo reportar error si no se encontró ni mapeó
        if (!operatoriaEncontrada) {
          console.log(
            `❌ Operatoria no encontrada ni mapeada: ${nombreOperatoria}`
          );
        }
      });

      if (fideicomisosDesdeOperatorias.length > 0) {
        params.fideicomisosId = [...new Set(fideicomisosDesdeOperatorias)].join(
          ','
        );
        console.log('✅ FideicomisosId establecido:', params.fideicomisosId);
      }

      if (operatoriasIds.length > 0) {
        params.operatoriasIds = [...new Set(operatoriasIds)].join(',');
        console.log('✅ OperatoriasIds establecido:', params.operatoriasIds);
      } else {
        console.log('❌ No se pudo establecer operatoriasIds - array vacío');
      }

      // Debug final de parámetros para Info Cobranzas Proyectadas
      console.log('🎯 Parámetros finales Info Cobranzas Proyectadas:', {
        fideicomisosId: params.fideicomisosId,
        operatoriasIds: params.operatoriasIds,
        page: params.page,
        limit: params.limit,
      });
    }

    return params;
  }

  static obtenerHeadersTabla(
    tiposServicios,
    filtroTipoServicio,
    tipoReporte = null
  ) {
    const tipoServicio = tiposServicios.find(
      (ts) => ts.id === filtroTipoServicio
    );
    const nombreTipoServicio = tipoServicio ? tipoServicio.nombre : '';

    const headersBase = [
      { text: 'Legajo', value: 'legajo' },
      { text: 'Operatoria / Línea', value: 'operatoria_linea', width: '200px' },
      {
        text: 'Apellido y Nombre / Razón Social',
        value: 'nombre_razon_social',
      },
      { text: 'CUIT', value: 'cuit' },
      { text: 'Departamento', value: 'departamento' },
      { text: 'Persona', value: 'persona' },
      { text: 'Fecha de Ingreso', value: 'fecha_ingreso' },
      { text: 'Estado', value: 'estado' },
      // Para Financiamiento (excepto Info Mora e Info Cte y No Cte): agregar Monto Aprobado antes de Monto Otorgado
      ...(nombreTipoServicio === 'Financiamiento' &&
          tipoReporte !== 'Info Mora (Financiamiento)' &&
          tipoReporte !== 'Info Cte y No Cte'
        ? [{ text: 'Monto Aprobado', value: 'monto_aprobado' }]
        : []),
      // Para ANR, Info Mora, Info Cte y No Cte, Info Cobranzas y Saldos HTC no incluir Monto Otorgado aquí, se maneja en headers específicos
      ...(nombreTipoServicio !== 'ANR' &&
          tipoReporte !== 'Info Mora (Financiamiento)' &&
          tipoReporte !== 'Info Cte y No Cte' &&
          tipoReporte !== 'Info Cobranzas' &&
          tipoReporte !== 'Info Cobranzas Proyectadas' &&
          tipoReporte !== 'Reporte de Saldos - HTC'
        ? [{ text: 'Monto Otorgado', value: 'monto' }]
        : []),
      // Para Financiamiento (excepto Info Mora e Info Cte y No Cte): agregar Monto Pendiente después de Monto Otorgado
      ...(nombreTipoServicio === 'Financiamiento' &&
          tipoReporte !== 'Info Mora (Financiamiento)' &&
          tipoReporte !== 'Info Cte y No Cte'
        ? [{ text: 'Monto Pendiente', value: 'monto_pendiente' }]
        : []),
    ];

    let headersEspecificos = [];

    if (tipoReporte === 'Info Mora (Financiamiento)') {
      headersEspecificos = [
        { text: 'Monto ANR', value: 'monto_anr' },
        { text: 'Monto Crédito', value: 'monto_credito' },
        { text: 'Monto Otorgado', value: 'monto_otorgado' },
        { text: 'Fecha de Otorgamiento', value: 'fecha_otorgamiento' },
        { text: 'Cantidad Cuotas', value: 'cantidad_cuotas' },
        { text: 'Saldo Capital', value: 'saldo_capital' },
        { text: 'Monto Cobrado', value: 'monto_cobrado' },
        { text: 'Cuotas en Mora', value: 'cantidad_cuotas_mora' },
        { text: 'Monto Vencido', value: 'capital_vencido' },
        { text: 'Monto en Mora', value: 'monto_mora' },
        { text: 'Días de Mora', value: 'dias_mora' },
        { text: 'Estado Morosidad', value: 'estado_morosidad' },
        { text: 'Porcentaje de Mora', value: 'porcentaje_mora' },
        { text: 'Estado Manual', value: 'estado_manual' },
      ];
    } else if (tipoReporte === 'Info Cobranzas Proyectadas') {
      headersEspecificos = [
        { text: 'Fecha de Otorgamiento', value: 'fechaOtorgamiento' },
        { text: 'Saldo Capital', value: 'saldo_capital' },
        { text: 'Próx. Vencimiento', value: 'proximo_vencimiento' },
        { text: 'Cuotas Pendientes', value: 'cuotas_pendientes' },
        { text: 'Días hasta Vencimiento', value: 'dias_hasta_vencimiento' },
      ];
    } else if (tipoReporte === 'Info Cobranzas') {
      headersEspecificos = [
        { text: 'Estado Manual', value: 'estado_manual' },
        { text: 'Período', value: 'periodo' },
        { text: 'Fecha Período', value: 'fecimputa' },
        { text: 'Monto Cobrado', value: 'cobrado' },
        { text: 'Fecha Vencimiento', value: 'fechaVencimiento' },
        { text: 'Monto Cuota', value: 'montoCuota' },
      ];
    } else if (tipoReporte === 'Info Cte y No Cte') {
      headersEspecificos = [
        { text: 'Monto del Crédito', value: 'monto_otorgado' },
        { text: 'Saldo Capital', value: 'saldo_capital_total' },
        { text: 'Corriente', value: 'capital_corriente' },
        { text: 'No Corriente', value: 'capital_no_corriente' },
      ];
    } else if (tipoReporte === 'Reporte de Saldos - HTC') {
      headersEspecificos = [
        { text: 'Fecha de Otorgamiento', value: 'fecha_otorgamiento' },
        { text: 'Fecha de Vencimiento de la Obligación', value: 'fecha_vencimiento_obligacion' },
        { text: 'Fecha Último Vto. de la Obligación', value: 'fecha_ultimo_vencimiento' },
        { text: 'Saldo Inicial del Período', value: 'saldo_inicial_periodo' },
        { text: 'Intereses Compensatorios (1)', value: 'intereses_compensatorios' },
        { text: 'Débitos del Período (2)', value: 'debitos_del_periodo' },
        { text: 'Créditos del Período (3)', value: 'creditos_del_periodo' },
        { text: 'Saldo Final del Período', value: 'saldo_final_periodo' },
        { text: 'Estado de Gestión de Cobranzas', value: 'estado_morosidad' },
        { text: 'Responsable de la Gestión', value: 'responsable_gestion' },
        { text: 'Estado Manual', value: 'estado_manual' },
      ];
    } else if (nombreTipoServicio === 'ANR') {
      headersEspecificos = [
        { text: 'Monto Solicitado', value: 'monto_total_solicitado' },
        { text: 'Monto Aprobado', value: 'monto_aprobado' },
        { text: 'Monto Otorgado', value: 'monto' },
        { text: 'Monto Pendiente', value: 'monto_pendiende' },
      ];
    } else if (nombreTipoServicio === 'Financiamiento') {
      headersEspecificos = [
        {
          text: 'Fecha de Otorgamiento',
          value: 'fechaOtorgamiento',
        },
        {
          text: 'Honorarios MF',
          value: 'honorarios_mf',
        },
        {
          text: 'Gastos de Escribano',
          value: 'gastos_escribano',
        },
        {
          text: 'Otros Gastos',
          value: 'otros_gastos',
        },
      ];
    } else if (nombreTipoServicio === 'Mendoza Activa') {
      headersEspecificos = [
        {
          text: 'Monto Mendoza Activa Solicitado',
          value: 'monto_total_solicitado',
        },
      ];
    } else {
      headersEspecificos = [
        { text: 'Monto Solicitado', value: 'monto_total_solicitado' },
      ];
    }

    return [...headersBase, ...headersEspecificos];
  }

  static obtenerTipoOperacion(tiposServicios, filtroTipoServicio) {
    const tipoServicio = tiposServicios.find(
      (ts) => ts.id === filtroTipoServicio
    );
    const nombreTipoServicio = tipoServicio ? tipoServicio.nombre : '';

    switch (nombreTipoServicio) {
      case 'ANR':
        return 'ANR';
      case 'Financiamiento':
        return 'Financiamiento';
      case 'Mendoza Activa':
        return 'Activa';
    }
    return 'Financiamiento';
  }

  static construirFiltrosActivos(contexto) {
    const filtros = [];

    // 1. Fideicomiso
    if (contexto.filtroFideicomiso && contexto.filtroFideicomiso.length > 0) {
      // Asegurar que filtroFideicomiso sea un array
      const fideicomisos = Array.isArray(contexto.filtroFideicomiso)
        ? contexto.filtroFideicomiso
        : contexto.filtroFideicomiso
        ? [contexto.filtroFideicomiso]
        : [];

      filtros.push({
        id: 'fideicomiso',
        etiqueta: 'Fideicomiso',
        nombre: fideicomisos.join(', '),
        fideicomisoNombres: fideicomisos,
      });
    } else {
      filtros.push({
        id: 'fideicomiso',
        etiqueta: 'Fideicomiso',
        nombre: 'Todos seleccionados',
      });
    }

    // 2. Tipo de Servicio
    if (contexto.filtroTipoServicio) {
      const servicioSeleccionado = contexto.tiposServicios.find(
        (s) => s.id === contexto.filtroTipoServicio
      );

      filtros.push({
        id: 'tipoServicio',
        etiqueta: 'Tipo de Operatoria',
        nombre: servicioSeleccionado
          ? servicioSeleccionado.nombre
          : contexto.filtroTipoServicio,
      });
    } else {
      filtros.push({
        id: 'tipoServicio',
        etiqueta: 'Tipo de Operatoria',
        nombre: 'Ninguno seleccionado',
      });
    }

    // 3. Operatoria
    if (contexto.filtroOperatoria && contexto.filtroOperatoria.length > 0) {
      filtros.push({
        id: 'operatoria',
        etiqueta: 'Operatoria',
        nombre: contexto.filtroOperatoria.join(', '),
        operatoriaNombres: contexto.filtroOperatoria,
      });
    } else {
      filtros.push({
        id: 'operatoria',
        etiqueta: 'Operatoria',
        nombre: 'Todas',
      });
    }

    // 4. Estado de Solicitud
    if (contexto.estadoSeleccionado && contexto.estadoSeleccionado.length > 0) {
      if (contexto.estadoSeleccionado.includes('todas')) {
        filtros.push({
          id: 'estadoSolicitud',
          etiqueta: 'Estado de Solicitud',
          nombre: 'Todas',
        });
      } else {
        const estadosNombres = contexto.estadoSeleccionado.map((estadoId) => {
          const estado = contexto.solicitudEstados.find(
            (e) => e.id === estadoId
          );
          return estado ? estado.nombre : estadoId;
        });

        filtros.push({
          id: 'estadoSolicitud',
          etiqueta: 'Estado de Solicitud',
          nombre: estadosNombres.join(', '),
          estadosNombres: estadosNombres,
        });
      }
    } else {
      filtros.push({
        id: 'estadoSolicitud',
        etiqueta: 'Estado de Solicitud',
        nombre: 'Todas',
      });
    }

    // 5. Tipo de Persona
    if (contexto.filtroTipoPersona && contexto.filtroTipoPersona !== 'Ambas') {
      filtros.push({
        id: 'tipoPersona',
        etiqueta: 'Tipo de Persona',
        nombre: contexto.filtroTipoPersona,
      });
    } else {
      filtros.push({
        id: 'tipoPersona',
        etiqueta: 'Tipo de Persona',
        nombre: 'Ambas',
      });
    }

    // 6. Departamentos - Ocultar para Info Cte y No Cte y Reporte de Saldos - HTC
    if (contexto.reporteEspecialActivo !== 'Info Cte y No Cte' &&
        contexto.reporteEspecialActivo !== 'Reporte de Saldos - HTC') {
      if (contexto.filtroDepartamento && contexto.filtroDepartamento.length > 0) {
        const departamentosNombres = contexto.filtroDepartamento.map((deptoId) => {
          const depto = contexto.departamentos.find((d) => d.id === deptoId);
          return depto ? depto.nombre : deptoId;
        });
        filtros.push({
          id: 'departamentos',
          etiqueta: 'Departamentos',
          departamentosNombres: departamentosNombres,
        });
      }
    }

    // 7. Fechas - Ocultar para Info Cte y No Cte y Reporte de Saldos - HTC
    if (contexto.reporteEspecialActivo !== 'Info Cte y No Cte' &&
        contexto.reporteEspecialActivo !== 'Reporte de Saldos - HTC') {
      const fechaPorDefectoInicio = '2020-01-01';
      const fechaPorDefectoFinal = new Date().toISOString().substr(0, 10);
      const esFechaInicioPorDefecto =
        contexto.fechaInicio === fechaPorDefectoInicio;
      const esFechaFinalPorDefecto = contexto.fechaFinal === fechaPorDefectoFinal;

      filtros.push({
        id: 'fechaInicio',
        etiqueta: 'Fecha Desde',
        nombre: contexto.fechaInicio
          ? this.formatearFecha(contexto.fechaInicio)
          : '01/01/2020',
        esPorDefecto: esFechaInicioPorDefecto,
      });

      filtros.push({
        id: 'fechaFinal',
        etiqueta: 'Fecha Hasta',
        nombre: contexto.fechaFinal
          ? this.formatearFecha(contexto.fechaFinal)
          : this.formatearFecha(fechaPorDefectoFinal),
        esPorDefecto: esFechaFinalPorDefecto,
      });
    }

    return filtros;
  }

  static validarGeneracionReporte(
    filtroTipoServicio,
    filtroOperatoria,
    reporteEspecialActivo = null
  ) {
    // Si hay un reporte especial activo, bloquear el botón generar reporte normal
    if (reporteEspecialActivo) {
      return false;
    }

    const tieneTipoServicio = !!filtroTipoServicio;
    const tieneOperatoriaEspecifica =
      filtroOperatoria &&
      filtroOperatoria.length > 0 &&
      !(filtroOperatoria.length === 1 && filtroOperatoria[0] === 'Todas');

    return tieneTipoServicio || tieneOperatoriaEspecifica;
  }

  static limpiarFiltrosHandler() {
    return {
      filtroTipoServicio: null,
      filtroFideicomiso: [],
      filtroOperatoria: [],
      estadoSeleccionado: [],
      filtroTipoPersona: 'Ambas',
      filtroDepartamento: [],
      fechaInicio: '2020-01-01',
      fechaFinal: new Date().toISOString().substr(0, 10),
      selectedParams: [],
      operatorias: [{ id: 'todas', nombre: 'Todas' }],
      mostrarSubtotales: false,
    };
  }
}

export default ReportesHelpers;
